/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_LimitedInputs */

const en_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some metadata is unavailable because this image blocks cross-origin reads. Dimensions and snippets still work.`)
};

const ar_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بعض البيانات الوصفية غير متاحة لأن هذه الصورة تمنع القراءة عبر النطاقات. الأبعاد والمقتطفات ما زالت تعمل.`)
};

const bn_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কিছু মেটাডেটা পাওয়া যাচ্ছে না, কারণ এই ছবিটি ক্রস-অরিজিন পড়া ব্লক করে। আকার ও স্নিপেট এখনও কাজ করবে।`)
};

const de_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Metadaten sind nicht verfügbar, weil dieses Bild Cross-Origin-Zugriffe blockiert. Abmessungen und Snippets funktionieren weiterhin.`)
};

const es_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunos metadatos no están disponibles porque esta imagen bloquea las lecturas de origen cruzado. Las dimensiones y los fragmentos siguen funcionando.`)
};

const fr_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certaines métadonnées sont indisponibles car cette image bloque les lectures cross-origin. Les dimensions et les extraits fonctionnent toujours.`)
};

const pt_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns metadados não estão disponíveis porque esta imagem bloqueia leituras de origem cruzada. As dimensões e os trechos continuam funcionando.`)
};

const zh_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分元数据不可用，因为该图片阻止跨域读取。尺寸和代码片段仍可正常使用。`)
};

const tr_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bazı meta veriler kullanılamıyor çünkü bu görsel siteler arası okumayı engelliyor. Boyutlar ve parçacıklar hâlâ çalışıyor.`)
};

const ru_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часть метаданных недоступна: изображение блокирует кросс-доменное чтение. Размеры и фрагменты работают.`)
};

const pl_image_inspector_limited = /** @type {(inputs: Image_Inspector_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Część metadanych jest niedostępna, ponieważ ten obraz blokuje odczyty cross-origin. Wymiary i fragmenty nadal działają.`)
};

/**
* | output |
* | --- |
* | "Some metadata is unavailable because this image blocks cross-origin reads. Dimensions and snippets still work." |
*
* @param {Image_Inspector_LimitedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_limited = /** @type {((inputs?: Image_Inspector_LimitedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_LimitedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_limited(inputs)
	if (locale === "bn") return bn_image_inspector_limited(inputs)
	if (locale === "de") return de_image_inspector_limited(inputs)
	if (locale === "es") return es_image_inspector_limited(inputs)
	if (locale === "fr") return fr_image_inspector_limited(inputs)
	if (locale === "pt") return pt_image_inspector_limited(inputs)
	if (locale === "zh") return zh_image_inspector_limited(inputs)
	if (locale === "tr") return tr_image_inspector_limited(inputs)
	if (locale === "ru") return ru_image_inspector_limited(inputs)
	if (locale === "pl") return pl_image_inspector_limited(inputs)
	return en_image_inspector_limited(inputs)
});